module.exports = __webpack_public_path__ + "static/fonts/element-icons.732389d.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/fonts/element-icons.ttf
// module id = 1756
// module chunks = 159